<template>
  <div
    :class="[
      $style.formCard,
      strong && $style.strong,
      windowsWidth <=700 && $style.mobileFormCard
    ]"
  >
    <slot />
  </div>
</template>

<style lang="scss" module>

.formCard {
  box-sizing: border-box;
  padding: 20px;
  text-align: left;
  border-radius: 5px;

  &:not(.strong) {
    margin-bottom: 50px;
    border: solid 1px #f3f3f3;
    background-color: #fff;
    box-shadow: 0 2px 14px 0 rgba(229, 229, 229, 0.5);
  }

  &.mobileFormCard {
    margin-bottom: 150px;
  }

  &.strong {
    border: solid 1px #dcdcdc;
    background-color: #fff;
    box-shadow: 0 4px 7px 0 rgba(240, 240, 240, 0.5);
  }

  @include for-tablet-landscape-up {
    padding: 28px 40px;
  }
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    strong: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      windowsWidth: state => state.ui.windowsWidth,
    }),
  },
};
</script>
